import React from "react";
import { useRouter } from "next/router";
import dynamic from "next/dynamic";

import styles from "./ServicePage.module.scss";
import { Col, Container, Row } from "react-bootstrap";
import Link from "next/link";
import { FormattedMessage } from "react-intl";
import Image from "next/future/image";
import BlueHoleIcon from "../../../public/logo.png";
import { buildApiUrl } from "src/helpers/imageHelpers";
import BreadCrumb from "src/components/shared/breadCrumb/Index";
const PageHeader = dynamic(
  () => import("src/components/shared/PageHeader/PageHeader"),
);

const DownloadSection = dynamic(
  () => import("src/components/shared/DownloadSection/DownloadSection"),
);
const Footer = dynamic(() => import("src/components/shared/Footer/Footer.jsx"));
const Testmonial = dynamic(
  () => import("src/components/HomePage/Testmonials/Testmonials.jsx"),
);
const AllServices = dynamic(
  () => import("src/components/ServicesPage/Services.jsx"),
);
const CommonQuestions = dynamic(
  () => import("src/components/shared/CommonQuestions/CommonQuestions.jsx"),
);

const SingleServicePage = ({ data }) => {
  const router = useRouter();
  const { locale } = router;
  const testmonialsData = data?.testmonialsData?.[0]?.categories?.[0]?.posts;
  // =========================================================

  const singleServiceData = data?.singleServiceData;
  // =========================================================

  const AllServicesData = data?.AllServicesData?.services;
  const filteredServices = data.singleServiceData.children_service;

  // =========================================================
  const questionsData = data?.questions?.[0]?.categories?.[0]?.posts;
  const targetQuestion = questionsData?.find((question) => question.id === 415);
  const commonQuestionsBackgroundImage = targetQuestion?.data?.image;
  const serviceQuestionsRaw = singleServiceData?.questions;
  const serviceQuestions = Array.isArray(serviceQuestionsRaw)
    ? serviceQuestionsRaw.map((q, index) => ({
        id: `service-question-${index}`,
        data: {
          title: {
            ar: q?.question_ar || "",
            en: q?.question_en || "",
          },
          description: {
            ar: q?.answer_ar || "",
            en: q?.answer_en || "",
          },
        },
      }))
    : [];
  const shouldShowServiceQuestions = serviceQuestions.length > 0;
  // =========================================================


  console.log(singleServiceData);

  return (
    <div className={styles.services}>
      <PageHeader />

      <BreadCrumb title={singleServiceData?.title?.[locale]} />
      <div className="singleServiceContent">
        <Container>
          <Row className="flex-row-reverse justify-content-between">
            {singleServiceData?.image && (
              <Col xs={12} md={6}>
                <div className="img">
                  <Image
                    src={buildApiUrl(singleServiceData?.image)}
                    width={500}
                    height={500}
                    alt="singleService-img"
                    property={true}
                  />
                </div>
              </Col>
            )}
            <Col xs={12} md={6} dir={locale === "ar" ? "rtl" : "ltr"}>
              <div className="content">
                <div
                  dangerouslySetInnerHTML={{
                    __html: singleServiceData?.page_content?.[locale],
                  }}
                />

                {singleServiceData?.features.length > 0 && (
                  <div className="features">
                    <div className="custom-head">
                      {/* <Image
                        src={BlueHoleIcon}
                        alt="icon"
                        className={styles.BlueHoleIcon}
                        width={100}
                        height={100}
                        property={true}
                      /> */}
                      <p>
                        <FormattedMessage id="features" />
                      </p>
                    </div>
                    <ul className="featuresList">
                      {singleServiceData?.features?.map((feature, index) => (
                        <li dir={locale === "ar" ? "rtl" : "ltr"} key={index}>
                          {feature?.[locale] || feature}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </div>


      {filteredServices?.length > 0 && (
        <AllServices AllServicesData={filteredServices} />
      )}
      {/* <Testmonial testmonialsData={testmonialsData} /> */}


      {shouldShowServiceQuestions && (
        <CommonQuestions
          commonQuestionsBackgroundImage={commonQuestionsBackgroundImage}
          filteredQuestions={serviceQuestions}
        />
      )}
      {/* {singleServiceData.catalog && (
        <DownloadSection
          file={singleServiceData?.catalog}
          // text={singleServiceData?.catalogName}
        />
      )} */}

      <Footer />
    </div>
  );
};

export default SingleServicePage;
